import { type MCPServerInfo } from '../../types';

const Context7OAuthServer: MCPServerInfo = {
  serverId: 'CONTEXT7_OAUTH',
  name: 'Context7 (Authenticated)',
  slug: 'context7-oauth',
  description: 'Up-to-date code documentation for LLMs and AI code editors.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.context7.com/mcp/oauth',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default Context7OAuthServer;
